import { render, staticRenderFns } from "./PurchaseOption.vue?vue&type=template&id=9aef1aca&scoped=true&"
import script from "./PurchaseOption.vue?vue&type=script&lang=ts&"
export * from "./PurchaseOption.vue?vue&type=script&lang=ts&"
import style0 from "./PurchaseOption.vue?vue&type=style&index=0&id=9aef1aca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aef1aca",
  null
  
)

export default component.exports